import { render, staticRenderFns } from "./IOS.vue?vue&type=template&id=cd6ec284&"
import script from "./IOS.vue?vue&type=script&lang=js&"
export * from "./IOS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports